import { render, staticRenderFns } from "./GaPixel.vue?vue&type=template&id=495b796e&"
import script from "./GaPixel.vue?vue&type=script&lang=js&"
export * from "./GaPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports